import React, { createContext, useState } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Modal } from 'shared/ui/modal/Modal';

type ModalModel = {
    id: string,
    body: React.ReactNode
    title: string
}

interface IModalContext {
    modals: ModalModel[]
    closeLastModal?: () => void
    closeModalById?: (id: string) => void
    openModal?: (modal: ModalModel) => void
}

export const ModalContext = createContext<IModalContext>({
    modals: [],
});

type ModalProviderProps = {
    children: React.ReactNode
}

export const ModalProvider: React.FC<ModalProviderProps> = ({
    children,
}) => {
    const [modals, setModals] = useState<ModalModel[]>([]);

    const closeLastModal = () => {
        const newModals = modals;
        newModals.pop();

        setModals(newModals);
    };

    const closeModalById = (id: string) => (
        setModals(modals.filter(({ id: id2 }) => id !== id2))
    );

    const openModal = (modal: ModalModel) => (
        setModals([...modals, modal])
    );

    return (
        <ModalContext.Provider
            // eslint-disable-next-line react/jsx-no-constructed-context-values
            value={{
                modals,
                closeLastModal,
                closeModalById,
                openModal,
            }}
        >
            {children}
            {modals.map(({ body, title, id }) => (
                <Modal
                    id={id}
                    title={title}
                >
                    {body}
                </Modal>
            ))}
        </ModalContext.Provider>
    );
};
